// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3CEeG","col":"styles_col__3D6cU"};